export const appConfig = {
    BASE_URL: process.env.REACT_APP_API,
    // BASE_URL: 'https://43b3-124-29-237-250.ngrok.io/dev/api',
    // BASE_URL: 'https://db39-103-217-178-170.ap.ngrok.io/dev/api',
    // BASE_URL: 'https://hquw6i3gyh.execute-api.ap-southeast-1.amazonaws.com/staging/api',
    // BASE_URL: 'https://auvihb9ipg.execute-api.ap-southeast-1.amazonaws.com/staging/api',

    RecordsPerPage: 15,
    MaxPages: 5,
    S3: {
        bucketName: 'agora-qbank',
        region: 'ap-southeast-1',
        accessKeyId: 'AKIAVVODWIG6INM4M3Q2',
        secretAccessKey: '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'
    }
};
